<template>
  <svg xmlns="http://www.w3.org/2000/svg" :height="size + 'px'" viewBox="0 -960 960 960" :width="size + 'px'" fill="currentColor">
    <path d="M440-80v-647L256-544l-56-56 280-280 280 280-56 57-184-184v647h-80Z"/>
  </svg>
</template>

<script>
import IconBase from "@/mixins/Icon/IconBase";

export default {
  name: "IconArrowNorth",
  mixins: [ IconBase ],
  props: { ...IconBase.props }
}
</script>